export interface UserDetails {
  billingUserId: number;
  blockedAt: string;
  blockReason: string;
  cognitoEnabled: boolean;
  cognitoStatus: string;
  cognitoUserId: string;
  createdAt: string;
  deletedAt: string;
  email: string;
  firstName: string;
  fraudAllowedAt: string;
  fraudBlockedAt: string;
  fraudDescription: Record<string, any>;
  fraudDetectedAt: string;
  fraudReason: string;
  id: string;
  lastName: string;
  note: string;
  phone: string;
  singlePayerAccountNumber: string;
  trackingNumberSource: string;
  trackingNumberUserAccount: string;
  shippingBlocked: boolean;
  chargingBlockedAt: string;
  chargingBlockedReason: string;
  smallPackagesAllowedAt: string | null;
  kycStatus?: 'REQUIRED' | 'STARTED' | 'COMPLETED' | 'FAILED' | null;
  kycSessionId?: string | null;
  kycStripeLink?: string | null;
  kycVerified?: boolean;
  expeditedShipmentsAllowedAt?: string | null;
}

export enum TransactionType {
  Purchase = 'PURCHASE',
  Deposit = 'DEPOSIT',
  AdminPurchase = 'ADMIN_PURCHASE',
  AdminDeposit = 'ADMIN_DEPOSIT',
  PurchaseAdjustment = 'PURCHASE_ADJUSTMENT',
  DepositAdjustment = 'DEPOSIT_ADJUSTMENT',
  Refund = 'REFUND',
  CreditCodes = 'CREDIT_CODE',
}

export interface RefundTransaction {
  amount: number;
  id: string;
  recordId: string;
}

export interface MemberDTO {
  id: string;
  firstName: string;
  secondName: string;
  phone: string;
  email: string;
  position: string;
  enabled: boolean;
  roles: string[];
  createdAt: string;
  updatedAt: string;
}

export interface TransactionAmountDTO {
  currency: 'CAD' | 'USD' | 'LABEL';
  amount: number;
}

export interface TransactionDTO {
  id?: string;
  correctedId?: string;
  description?: string;
  amount?: TransactionAmountDTO;
  initialBalance?: TransactionAmountDTO;
  type?: TransactionType;
  createdAt?: string;
  details?: Record<string, any>;
}

export interface DeliveryServiceProviderDTO {
  code?: string;
  shortName?: string;
  fullName?: string;
  logoUrl?: string;
  disclaimer?: string;
}

export interface ShipmentInfo {
  id?: string;
  provider?: DeliveryServiceProviderDTO;
  trackNumber?: string;
  trackLink?: string;
  carrier?:
    | 'UPS'
    | 'USPS'
    | 'FEDEX'
    | 'OTHER'
    | 'ROLLODELIVERY'
    | 'CANADA_POST'
    | 'PUROLATOR'
    | 'TIKTOK_DELIVERY';
  serviceProviders?:
    | 'Amazon'
    | 'BigCartel'
    | 'BigCommerce'
    | 'Cart3d'
    | 'eBay'
    | 'Ecwid'
    | 'ETSY'
    | 'Magento'
    | 'BestBuy'
    | 'PayPal'
    | 'RolloApp'
    | 'Shopify'
    | 'Squarespace'
    | 'Square'
    | 'TikTok'
    | 'Walmart'
    | 'Wix'
    | 'WooCommerce';
  orderSource?: 'CSV' | 'MANUAL' | 'SELLING_CHANNELS' | 'QUICK_SHIPMENT';
  packageType?: string;
  serviceName?: string;
  interceptedAt?: string;
  interceptionType?:
    | 'RETURN_TO_SENDER'
    | 'REROUTE_TO_DIFFERENT_ADDRESS'
    | 'RESCHEDULE_DELIVERY'
    | 'HOLD_AT_FACILITY';
  alternateTrackNumbers?: string[];
}

export interface TransactionGroupDTO {
  id?: string;
  details?: Record<string, any>;
  status?: 'CONFIRMED' | 'REVIEW' | 'CANCELLED' | 'PENDING' | 'ON_HOLD' | 'FAILED';
  amounts?: Record<string, number>;
  type?: TransactionType;
  transactions?: TransactionDTO[];
  createdAt?: string;
  shipmentInfo?: ShipmentInfo;
  stripeLink?: string;
}
